/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateMetricValueDto } from './CreateMetricValueDto';
import {
    CreateMetricValueDtoFromJSON,
    CreateMetricValueDtoFromJSONTyped,
    CreateMetricValueDtoToJSON,
    CreateMetricValueDtoToJSONTyped,
} from './CreateMetricValueDto';

/**
 * 
 * @export
 * @interface CreateBulkMetricValuesDto
 */
export interface CreateBulkMetricValuesDto {
    /**
     * Bulk data containing array of metric values to create
     * @type {Array<CreateMetricValueDto>}
     * @memberof CreateBulkMetricValuesDto
     */
    bulkData: Array<CreateMetricValueDto>;
}

/**
 * Check if a given object implements the CreateBulkMetricValuesDto interface.
 */
export function instanceOfCreateBulkMetricValuesDto(value: object): value is CreateBulkMetricValuesDto {
    if (!('bulkData' in value) || value['bulkData'] === undefined) return false;
    return true;
}

export function CreateBulkMetricValuesDtoFromJSON(json: any): CreateBulkMetricValuesDto {
    return CreateBulkMetricValuesDtoFromJSONTyped(json, false);
}

export function CreateBulkMetricValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBulkMetricValuesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'bulkData': ((json['bulkData'] as Array<any>).map(CreateMetricValueDtoFromJSON)),
    };
}

export function CreateBulkMetricValuesDtoToJSON(json: any): CreateBulkMetricValuesDto {
    return CreateBulkMetricValuesDtoToJSONTyped(json, false);
}

export function CreateBulkMetricValuesDtoToJSONTyped(value?: CreateBulkMetricValuesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bulkData': ((value['bulkData'] as Array<any>).map(CreateMetricValueDtoToJSON)),
    };
}

